import React, { useEffect } from "react";
import { useAssessment } from "providers/Assessment";
import AssessmentCalculatingUplift from "./AssessmentCalculatingUplift";

const AssessmentInterstitialAnimation = () => {
  const { onSubmit } = useAssessment();

  useEffect(() => {
    onSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <AssessmentCalculatingUplift />;
};

export default AssessmentInterstitialAnimation;
